module.exports = __webpack_public_path__ + "img/whathot_bg_mobile_darkblue.10c7c0f6.png";